export default __webpack_public_path__ + "static/media/mobilecard.dc05db02.png";